import format from 'dateformat';
import {cloneDeep, get, set} from 'lodash';
import {connect} from 'react-redux';
import actionCreators from '../actionCreators';
import {updatePreferences} from '../actionCreators/preferences';
import {findSection, updateSectionValue} from '../ducks/reportSections';
import {updatePropertyPreferences as storePropertyPreference} from 'api/propertyPreferences';
import CustomiseCoverPageDetailsModal from './CustomiseCoverPageDetailsModal';

const sectionWithDefaults = (state, reportType) => {
	const section = cloneDeep(findSection(state.reportSections, reportType, 'COVER_PAGE'));
	const agentName = [state.userDetails.firstName, state.userDetails.lastName].join(' ');
	const agencyAddress = [state.userDetails.address1, state.userDetails.address2].join(' ');
	const agencyAddressDetails = [state.userDetails.suburb, state.userDetails.state, state.userDetails.postalCode].join(' ');

	if (!get(section, 'sectionData.singleLineAddress')) {
		set(section, 'sectionData.singleLineAddress', state.propertyDetail.singleLineAddress);
	}
	if (!get(section, 'sectionData.preparedOn')) {
		set(section, 'sectionData.preparedOn', format(new Date(), 'dS mmmm yyyy'));
	}
	if (!get(section, 'sectionData.agentName')) {
		set(section, 'sectionData.agentName', agentName);
	}
	if (!get(section, 'sectionData.agency')) {
		set(section, 'sectionData.agency', state.userDetails.tradeName);
	}
	if (!get(section, 'sectionData.mobile')) {
		set(section, 'sectionData.mobile', state.userDetails.workMobileNumber);
	}
	if (!get(section, 'sectionData.landline')) {
		set(section, 'sectionData.landline', state.userDetails.workPhoneNumber);
	}
	if (!get(section, 'sectionData.email')) {
		set(section, 'sectionData.email', state.userDetails.workEmail);
	}
	if (!get(section, 'sectionData.agencyAddress')) {
		set(section, 'sectionData.agencyAddress', agencyAddress);
	}
	if (!get(section, 'sectionData.agencyAddress2')) {
		set(section, 'sectionData.agencyAddress2', agencyAddressDetails);
	}
	return section;
};

const mapStateToProps = (state) => {
	const reportType = state.reportType.value;
	const section = sectionWithDefaults(state, reportType);
	return {
		propertyId: state.propertyDetail.propertyId,
		reportType,
		section,
		sectionData: {...section.sectionData}
	};
};

const mapDispatchToProps = (dispatch) => ({
	updatePreferences: (preferences, reportType) => {
		dispatch(updatePreferences(preferences, reportType));
	},
	updateValue: (value, dataKeyPath, reportType) => {
		dispatch(updateSectionValue({
			dataKeyPath: `sectionData.${dataKeyPath}`,
			key: 'COVER_PAGE',
			reportType,
			value,
		}));
	},
	sendEvent: (section, value, dataKeyPath) => {
		const labels = {
			singleLineAddress: 'Vanity Address',
		};
		dispatch(actionCreators.sendEditTitleAnalyticsEvent(section, value, labels[dataKeyPath]));
	},
});

const mergeProps = (stateProps, dispatchProps) => ({
	...stateProps,
	...dispatchProps,
	onSave: ({sectionData = {}}) => {
		let sectionReportData = {};
		let thisReportData = {};

		let thisReportKeys = ['preparedFor', 'preparedOn', 'singleLineAddress'];
		Object.keys(sectionData).forEach(key => {
			if (thisReportKeys.indexOf(key) < 0) {
				sectionReportData[key] = sectionData[key];
			} else {
				thisReportData[key] = sectionData[key];
			}
		});

		if (sectionReportData) {
			let toStore = {};

			Object.keys(sectionReportData).forEach(key => {
				dispatchProps.updateValue(sectionReportData[key], key, stateProps.reportType);
				if (!key.match(/_isEnabled/i)) {
					dispatchProps.sendEvent(stateProps.section, sectionReportData[key], key);
				}
				toStore[`coverPage.sectionData.${key}`] = sectionReportData[key];
			});

			dispatchProps.updatePreferences(toStore, stateProps.reportType);
		}
		if (thisReportData) {
			let toStore = {};

			Object.keys(thisReportData).forEach(key => {
				dispatchProps.updateValue(thisReportData[key], key, stateProps.reportType);
				if (!key.match(/_isEnabled/i)) {
					dispatchProps.sendEvent(stateProps.section, thisReportData[key], key);
				}

				const keyPath = `cover_page.sectionData.${key}`;
				toStore[keyPath] = thisReportData[key];
			});

			storePropertyPreference(stateProps.propertyId, toStore);
		}
	},
});

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(CustomiseCoverPageDetailsModal);